<template>
  <div>
    <v-row>
      <v-col cols="12" md="9">
        <PeriodPicker
          frequencyLabel="Invoice Frequency"
          periodLabel="Period"
          :frequencyId="invoiceFrequencyId"
          :dateBegin="dateBegin"
          :dateEnd="dateEnd"
          @frequencyChange="frequencyChangeHandler"
          @periodChange="periodChangeHandler"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3"
        v-if="invoiceFrequencyId"
      >
        <BusinessEntitiesDropDownList
          :clearable="true"
          v-model="businessEntityId"
          includeAllBusinessEntitiesOption
          @businessEntityIdChange="businessEntityIdChangeHandler"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3"
        v-if="businessEntityId && businessEntityId !== ALL_BUSINESS_ENTITIES"
      >
        <ClientsDropDownList
          :clearable="true"
          :id="clientId"
          :businessEntityId="businessEntityId"
          @clientIdChange="(newValue) => clientId = newValue"
        />
      </v-col>
      <v-col cols="12" sm="6" md="3"
        v-if="invoiceFrequencyId"
      >
        <v-switch
          class="my-auto"
          v-model="showDetails"
          label="Show Details"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PeriodPicker } from '@/components/shared/datePickers'
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { BusinessEntitiesDropDownList } from '@/components/businessEntities/'
import { ALL_BUSINESS_ENTITIES } from '@/lib/constants/businessEntities'
import { ClientsDropDownList } from '@/components/clients'

export default {
  components: {
    PeriodPicker,
    BusinessEntitiesDropDownList,
    ClientsDropDownList
  },
  data () {
    return {
      ALL_BUSINESS_ENTITIES
    }
  },
  computed: {
    ...mapFields('invoicingReportFilters',
      [
        'invoiceFrequencyId',
        'dateBegin',
        'dateEnd',
        'businessEntityId',
        'clientId',
        'showDetails'
      ])
  },
  methods: {
    ...mapActions('invoicingReportFilters', ['clearFilters']),
    ...mapActions('invoicingReport', ['getInvoicingReportWithFilters']),
    frequencyChangeHandler (newValue) {
      this.emptyClientFilter()
      this.dateBegin = null
      this.dateEnd = null
      this.invoiceFrequencyId = newValue
    },
    periodChangeHandler (dateBegin, dateEnd) {
      this.emptyClientFilter()
      this.dateBegin = dateBegin
      this.dateEnd = dateEnd
      this.handleSearchClick()
    },
    emptyClientFilter () {
      this.clientId = null
    },
    businessEntityIdChangeHandler (newValue) {
      this.emptyClientFilter()
      this.businessEntityId = newValue
      this.handleSearchClick()
    },
    handleSearchClick () {
      this.getInvoicingReportWithFilters()
    }
  }
}
</script>
